module.exports = __webpack_public_path__ + "static/goodFriday-eeb14335f7885f3fb12b4b93ee9c69f5.jpg";